import { defineMessages } from '@jutro/locale';

export default defineMessages({
    specifyRecipients: {
        id: 'agent.directives.ml-document-recipients.Specify Recipients',
        defaultMessage: 'Specify Recipients'
    },
    other: {
        id: 'agent.directives.ml-document-recipients.Other',
        defaultMessage: 'Other'
    },
    addRecipients: {
        id: 'agent.directives.ml-document-recipients.Add Recipients',
        defaultMessage: 'Add Recipients'
    },
    deliveryMethod: {
        id: 'agent.directives.ml-document-recipients.Delivery Method',
        defaultMessage: 'Delivery Method'
    },
    faxNumber: {
        id: 'agent.directives.ml-document-recipients.Fax Number',
        defaultMessage: 'Fax Number'
    },
    emailAddress: {
        id: 'agent.directives.ml-document-recipients.Email Address',
        defaultMessage: 'Email Address'
    },
    uspsMessage: {
        id: 'agent.directives.ml-document-recipients.Documents will be mailed to the mailing address associated with your policy.',
        defaultMessage: 'Documents will be mailed to the mailing address associated with your policy.'
    },
    add: {
        id: 'agent.directives.ml-document-recipients.ADD',
        defaultMessage: 'ADD'
    },
    recipient: {
        id: 'agent.directives.ml-document-recipients.Recipient',
        defaultMessage: 'Recipient'
    },
    actions: {
        id: 'agent.directives.ml-document-recipients.Actions',
        defaultMessage: 'Actions'
    },
    remove: {
        id: 'agent.directives.ml-document-recipients.Remove',
        defaultMessage: 'Remove'
    },
    noRecipientsAdded: {
        id: 'agent.directives.ml-document-recipients.No Recipients Added',
        defaultMessage: 'No Recipients Added'
    },
    duplicatedEmailAlert: {
        id: 'agent.directives.MLDocumentRecipientsDirective.MLDocumentRecipientsDirectiveCtrl.This document requires signatures from multiple people. A unique email address is required for each person',
        defaultMessage: 'This document requires signatures from multiple people. A unique email address is required for each person'
    },
    eSignAlert: {
        id: 'agent.directives.MLDocumentRecipientsDirective.MLDocumentRecipientsDirectiveCtrl.When e-Signature is the selected delivery method, you must add the additional recipient',
        defaultMessage: 'When e-Signature is the selected delivery method, you must add the additional recipient'
    },
    nonESignAlert: {
        id: 'agent.directives.MLDocumentRecipientsDirective.MLDocumentRecipientsDirectiveCtrl.For this delivery method, only the primary insured can be selected',
        defaultMessage: 'For this delivery method, only the primary insured can be selected'
    },
    emailSubTypeNotAllowed: {
        id: 'agent.directives.ml-document-recipients.Email delivery is not available.  You may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance',
        defaultMessage: 'Email delivery is not available.  You may only select email delivery for the following: Quote proposals, signature forms, ID cards, and evidence/certificate of insurance'
    },
    cannotAddMoreEmailRecipients: {
        id: 'agent.directives.ml-document-recipients.You may only add two recipients to email delivery.  Please choose another delivery option for any additional recipients.',
        defaultMessage: 'You may only add two recipients to email delivery.  Please choose another delivery option for any additional recipients.'
    },
    cannotAddMoreFaxRecipients: {
        id: 'agent.directives.ml-document-recipients.You may only add one recipient to Fax delivery.  Please choose another delivery option for any additional recipients.',
        defaultMessage: 'You may only add one recipient to Fax delivery.  Please choose another delivery option for any additional recipients.'
    }
    
});
